import React from 'react';
import { TutorialUI } from './ui';

export const TutorialScreen: React.FC = (): JSX.Element => {
  return <TutorialUI />;
};
